import { useEffect, useState } from 'react';
import { useSystem } from './useUserInfo';
import { decryptByDESModeCBC } from '@/utils/crypto';

export const useMap = () => {
  const { systemData } = useSystem();
  const [isInitialled, setIsInitialled] = useState<boolean>(false);
  const [mapKey, setMapKey] = useState<string>('');
  useEffect(() => {
    // @ts-ignore
    if (systemData?.amap?.Secret) {
      const securityJsCode = decryptByDESModeCBC(systemData?.amap?.Secret || '') || '';
      // @ts-ignore
      window._AMapSecurityConfig = {
        securityJsCode,
      };
      setIsInitialled(!!securityJsCode);
    }
    setMapKey(systemData?.amap?.Key || '');
  }, [systemData]);
  return { isInitialled, mapKey };
};
